import { useContext, useState } from 'react';
import { RouterContext } from '../../../contexts/RouterContext';

const initialPage = 1;
const initialCount = 20;

/**
 * Hook to manage pagination state for the fossa analysis report.
 *
 * Note: It is mandatory that the callers of this hook call the setTotalItems function in order to manage the page and count state.
 */
const usePagination = () => {
  const [totalItems, setTotalItems] = useState(0);
  const { getQuery, setQuery } = useContext(RouterContext);
  const query = getQuery();

  return {
    page: Number(query.page) || initialPage,
    count: Number(query.count) || initialCount,
    totalItems,
    setTotalItems,
    setPage: (page: number) => setQuery({ ...query, page }),
    // Set the page back to initialPage when the count changes to avoid showing an empty page
    setCount: (count: number) => setQuery({ ...query, count, page: initialPage }),
  };
};

export default usePagination;
